module.exports = __webpack_public_path__ + "img/kachel-VERLETZUNGEN_propolis.26796521.png";